// Tambahkan 'export' di depan fungsi ini
export function formatTgl(dateStr) {
    if (!dateStr || dateStr === "0000-00-00" || dateStr === "null") return "-";

    try {
        const cleanDateStr = typeof dateStr === 'string' ? dateStr.split('T')[0] : dateStr;
        const parts = cleanDateStr.split('-');
        
        if (parts.length === 3) {
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const day = parseInt(parts[2], 10);

            const d = new Date(year, month, day);

            if (!isNaN(d.getTime())) {
                return d.toLocaleDateString("id-ID", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                });
            }
        }

        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return "-";

        return d.toLocaleDateString("id-ID", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch (error) {
        return "-";
    }
}

// Fungsi pembantu (opsional untuk internal)
function evaluateKeterangan(result, requirement) {
  if (!result || result === "-" || !requirement || requirement === "-") {
    return "-";
  }

  const numResult = parseFloat(result);
  const numReq = parseFloat(requirement);

  if (isNaN(numResult) || isNaN(numReq)) {
    return "-";
  }

  return numResult <= numReq ? "Compiled" : "Not Compiled";
}

// Fungsi flattenLaporan tetap diexport
export function flattenLaporan(headerRows = []) {
  if (!Array.isArray(headerRows)) return [];

  const result = [];

  headerRows.forEach((header, headerIndex) => {
    const details = Array.isArray(header.jenis_uji) && header.jenis_uji.length > 0
      ? header.jenis_uji
      : [{}];

    const headerRowSpan = details.length;

    details.forEach((detail, detailIndex) => {
      const master = detail.master_uji || {};
      const calculatedKeterangan = evaluateKeterangan(detail.result, master.requirement);

      result.push({
        key: `${header.id || headerIndex}-${detail.id || detailIndex}`,
        isFirstOfHeader: detailIndex === 0,
        headerRowSpan: headerRowSpan,

        // Data Level Header (Simpan nilai asli tanpa format)
        id_lab: header.id_lab || "-",
        nm_upi: header.nm_upi || "-",
        nm_jenis_uji: header.nm_jenis_uji || "-",
        tgl_contoh: header.tgl_contoh || null,
        tgl_sur: header.tgl_sur || null,
        tgl_lhu: header.tgl_lhu || null,
        tmp_uji: header.tmp_uji || "-",
        dokpath: header.dokpath || null,

        // Data Level Detail
        nm_uji: detail.nm_uji || master.parameter_uji || "-",
        result: detail.result ?? "-",
        satuan: detail.satuan || "-",
        kategori: master.kategori || detail.kategori || "-",
        methode: detail.methode || master.methode || "-",
        lod_loq: detail.lod_loq || (master.requirement ? `<= ${master.requirement}` : "-"),
        keterangan: detail.keterangan || calculatedKeterangan
      });
    });
  });

  return result;
}